import { RouterProvider } from 'react-router-dom'

import { ErrorBoundary } from '@/components/feedback/ErrorBoundary'
import { useSessionBootstrap } from '@/features/auth/hooks/useSessionBootstrap'
import { usePushServiceWorkerMessages } from '@/features/notificacoes/hooks/usePushServiceWorkerMessages'

import { AppProviders } from './providers'
import { router } from './routes'
import { useAppUpdater } from '@/hooks/useAppUpdater'

const navigateFromServiceWorker = (url: string) => void router.navigate(url)

export default function App() {
  // Restaura a sessão a partir do cookie httpOnly no start da aplicação.
  useSessionBootstrap()

  // Verifica periodicamente se há uma versão nova do PWA publicada
  // e atualiza sozinho (novo SW assume e a página recarrega).
  useAppUpdater()

  // Push recebido com o app aberto e clique em notificação (mensagens do SW).
  usePushServiceWorkerMessages(navigateFromServiceWorker)

  return (
    <ErrorBoundary>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </ErrorBoundary>
  )
}
